import React from "react";
import styles from "./index.module.scss";
import clsx from "clsx";
import translate from "../../../../i18n/translate";
import {useSelector} from "react-redux";
import {formatPriceParking} from "../../../../utils/formatPriceParking";
import {formatPriceStorage} from "../../../../utils/formatPriceStorage";
import {Space} from "antd";

export default function StorageRoom({ storageRoom, onStorageRoomClick, classNames, smallChess }) {
  const {rate} = useSelector(state => state.rate)

  const totalPrice = storageRoom.price || (storageRoom.m2 * storageRoom.pricePerMetrSquare);

  return (
    <div
      className={clsx(styles["apartment-container"], ...classNames)}
      onClick={onStorageRoomClick}
      style={{
        ...(smallChess
            ? { width: "50px", height: "50px" }
            : {}),
      }}
    >
      {smallChess ? (
        <div className={styles.smallChess}>
          <p>{storageRoom.number}</p>
        </div>
      ) : (
        <>
          <p>
              &#8470;
            <b>{storageRoom.number}</b>
          </p>
          <p>

            <b>{parseFloat(storageRoom.m2)}{translate("misc.sqm")}</b>
          </p>
          <p>
              {
                  storageRoom.orders[0]?.type==="sold" ?
                      <>
                      <p className={styles['apartment-sold']}>
                          {translate("status.sold")}
                      </p>
                          <Space>
                              <b>{translate("sale.user")}</b>
                              <p>
                                  {storageRoom.orders[0]?.user?.username}{" "}

                              </p>
                          </Space>
                          <br/>
                          <Space>
                              <b>{translate("sale.customer_name")}</b>
                              <p  style={{wordBreak:"break-all"}}>
                                  <span className={styles.lineClamp}>{storageRoom.orders[0]?.client?.customerName}</span>

                              </p>
                          </Space>
                      </>
            :
                      <b>{formatPriceStorage(storageRoom, rate)} {translate("misc.currency")}</b>
              }

          </p>
        </>
      )}
    </div>
  );
}